export const randomNumInRange = (max) => {
    return Math.floor(Math.random() * max) + 1;
}